import { ContentCheck, MenuClose, NoticeBullet } from '@fs/zion-icon'
import { colors, ListItem, Row } from '@fs/zion-ui'
import React, { useRef, useEffect, useCallback } from 'react'
import { css } from '@emotion/core'
import { useImageAuditContext } from '../../../hooks/useImageAuditContext'
import transl from '../imageQualityAudit.transl'

const colorText = (color) => css`
  color: ${color};
`

export default function AuditListItem({ item = null }) {
  const ref = useRef()
  const { focusedIndex, setFocusIndex, stickOnImage } = useImageAuditContext()

  useEffect(() => {
    // Only want this called if it is assigned
    if (item.imageNumber === focusedIndex + 1) ref.current.scrollIntoView?.()
  }, [item, focusedIndex])

  const StatusIcon = useCallback(() => {
    if (!item.viewed || !item.loaded) return <NoticeBullet color={colors.gray20} />
    if (item.auditIssues.length > 0) return <MenuClose color={colors.danger50} />
    return <ContentCheck aria-label={`image ${item.imageNumber} reviewed without issue`} color={colors.green50} />
  }, [item])

  const SecondaryText = useCallback(() => {
    const text = item?.auditIssues.map((issue) => issue.primaryText).join(', ')
    return text ? <span css={colorText(colors.gray70)}>{text}</span> : null
  }, [item?.auditIssues])

  return (
    <ListItem
      primaryText={
        <Row gutters="nano">
          <span css={colorText(colors.blue60)}>{transl.imageNumber(item.imageNumber)}</span>
          <span css={colorText(colors.gray50)}>{item.optional ? `(${transl.optional()})` : null}</span>
        </Row>
      }
      startElement={<ListItem.Icon Icon={StatusIcon} />}
      onClick={() => setFocusIndex(item.imageNumber)}
      selected={item.imageNumber - 1 === focusedIndex}
      secondaryText={<SecondaryText />}
      key={item.imageNumber}
      ref={ref}
      disabled={stickOnImage}
    />
  )
}
